import { useEffect, useMemo, useRef, useState } from 'react'
import { KeycloakService } from '@nv/auth'
import { KeycloakAdminService } from '@nv/auth'
import { useConfigurationContext } from '@nv/contexts'
import LanguageIcon from '@nv/images/design/langauge-icon'
import { AdminVoterService } from '@nv/services'
import { VoterAuthService } from '@nv/services'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import styles from './LanguagesDropdown.module.scss'

const LanguagesDropdown = ({ bgColor, txtColor }: any) => {
  const { languages } = useConfigurationContext()
  const [openDropdown, setOpenDropdown] = useState(false)
  const dropdownOptionsRef = useRef(null)
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  const updateLanguage = ({ newLanguage }) => {
    i18n.changeLanguage(newLanguage)
    setOpenDropdown(false)
    if (KeycloakService.isLoggedIn()) VoterAuthService.updateUserLanguage(newLanguage)
    if (KeycloakAdminService.isLoggedIn()) AdminVoterService.updateUserLanguage(newLanguage)
  }

  const renderSelect = useMemo(() => {
    return (
      <div
        className={styles['select']}
        onClick={!openDropdown ? () => setOpenDropdown(true) : null}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !openDropdown) setOpenDropdown(true)
        }}
        role='button'
        tabIndex={0}
      >
        <LanguageIcon color={'var(--color-white)'} />
        <span className={styles['select__selected-lang']} style={{ color: txtColor }}>
          {languages[currentLanguage] || t('main.defaultLanguage')}
        </span>
        <div
          style={{ background: txtColor }}
          className={clsx(styles['select__chevron'], {
            [styles['select__chevron--rotate']]: openDropdown,
          })}
        ></div>
      </div>
    )
  }, [openDropdown, currentLanguage])

  const DropdownOptions = () => (
    <div className={styles['options']} ref={dropdownOptionsRef} style={{ backgroundColor: bgColor }}>
      {Object.keys(languages).map((key) => (
        <div
          key={key}
          className={styles['options-item']}
          onClick={() => updateLanguage({ newLanguage: key })}
          onKeyDown={(e) => {
            if (e.key === 'Enter') updateLanguage({ newLanguage: key })
          }}
          role='button'
          tabIndex={0}
        >
          <span className={styles['options-item__label']} style={{ color: txtColor }}>
            {languages[key]}
          </span>
        </div>
      ))}
    </div>
  )

  const handleClickOutside = (event) => {
    if (dropdownOptionsRef.current && !dropdownOptionsRef.current.contains(event.target)) {
      setOpenDropdown(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className={styles['container']}>
      {renderSelect}
      {openDropdown && <DropdownOptions />}
    </div>
  )
}

export default LanguagesDropdown
